module.exports = __webpack_public_path__ + "static/preview-img2@2x-66e635a6763313f345100307f19f0171.png";